import { BasicInfoValues } from '../../types/DataCollectionValues';
import transformStringsToTypes from './transformStringsToTypes';

type apiResponseType = {
    status: 'OK' | 'NOK';
};

async function callBasicInfoApi(data: BasicInfoValues): Promise<apiResponseType> {
    // TODO: prepare a check if the data has been changed, if not do not call
    const API_URL = '/api/v1/otz/basic-info';
    const basicInfoData = transformStringsToTypes(data);
    const response = await fetch(API_URL, {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(basicInfoData),
    });
    if (!response.ok) {
        throw new Error('[callBasicInfoApi] communication error');
    }
    return response.json();
}

export default callBasicInfoApi;
